export interface IAppState {
  isFirstLogin: boolean;
  notifications: any[];
  warningModal: {
    title: string;
    description: string;
    isOpen: boolean;
  };
  refreshModal: {
    variant?: "update" | "migration";
    title: string;
    description: string;
    isOpen: boolean;
    confirmBtnText?: string;
    hideCancelButton?: boolean;
    onConfirm?: any;
  };
  sidebarExpanded: boolean;
}

const initialState: IAppState = {
  isFirstLogin: true,
  notifications: [],
  warningModal: {
    title: "",
    description: "",
    isOpen: false,
  },
  refreshModal: {
    variant: undefined,
    title: "",
    description: "",
    isOpen: false,
    confirmBtnText: undefined,
    hideCancelButton: undefined,
    onConfirm: undefined,
  },
  sidebarExpanded: false,
};

export default initialState;
